import './App.css';
import Hero from './components/Hero/Hero.jsx';
import Program from './components/Program/program';
import Reason from './components/Reasons/Reason';
import Plans from './components/Plans/plans';
import Testimanials from './components/Testimonials/Testimanials';
import Join from './components/Join/Join';
function App() {
  return (
    <div className="App">
          <Hero/>
          <Program/>
          <Reason/>
          <Plans/>
          <Testimanials/>
          <Join/>
    </div>
  );
}

export default App;
